<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.8485 19.75L6 21.75V7.5L10.8485 6M10.8485 19.75L17.1515 22M10.8485 19.75V6M17.1515 22L22 20.5V6.25L17.1515 8M17.1515 22V8M17.1515 8L10.8485 6" stroke="black"/>
</svg>
